import { _EVENTS_CHILD_ORDER } from "../../ui/utils/General";
import { apiEscuelaObtenerConfiguracion } from "../API";
import { _APP_DATA } from "../AppData";
import { EEventId, IApiResult, IEvent, IKinder } from "../models/Entities";
import { MEscuela } from "../models/MEscuela";
import { RequestData } from "../utils/RequestData";

export const _DICT_ESCUELAS = new (class extends Map<number, MEscuela> {
    /** Obtiene una escuela por id si está disponible en el diccionario, si no está disponible, la obtiene del servidor y la agrega al diccionario */
    async getOrFetch(idEscuela: number): Promise<MEscuela | null> {
        return new Promise<MEscuela | null>((resolve) => {
            if (this.has(idEscuela)) {
                resolve(this.get(idEscuela) || null);
            } else {
                _SvEscuelaObtenerConfiguracionByEscuela(idEscuela, () => {
                    resolve(this.get(idEscuela) || null);
                });
            }
        });
    }
    pendingFetches: Map<number, Promise<MEscuela | null>> = new Map();
})();

/** Escuela actual del grupo seleccionado */
export let _ESCUELA: MEscuela | null;

/**
 * Obtiene la configuración de la escuela seleccionada (del ultimo grupo seleccionado)
 * */
export function _SvEscuelaObtenerConfiguracion(
    /** @deprecated usar la promesa */
    callback?: () => void
): Promise<MEscuela | null> {

    return _SvEscuelaObtenerConfiguracionByEscuela(_APP_DATA.userData.IdKinder)
        .then((res) => {
            _ESCUELA = res;
            if (callback) callback();
            return res;
        });
}

export function _SvEscuelaObtenerConfiguracionByEscuela(
    idEscuela: number,
    /** @deprecated usar la promesa */
    callback?: () => void
): Promise<MEscuela | null> {

    if (_DICT_ESCUELAS.pendingFetches.has(idEscuela)) {
        const pendingFetch = _DICT_ESCUELAS.pendingFetches.get(idEscuela)!;
        return Promise.resolve(pendingFetch).then((res) => {
            if (callback) callback();
            return res;
        });
    }

    let req: RequestData<IApiResult<IKinder>>;
    const fetchPromise = new Promise<MEscuela | null>((resolve) => {
        const params = {
            IdEscuela: idEscuela
        }

        req = new RequestData<IApiResult<IKinder>>(apiEscuelaObtenerConfiguracion)
            .Params(params)
            .Completion((response, error) => {
                const resultData = response?.Datos || null;

                if (error)
                    console.log(error.name, error.message);

                const reqEscuela = resultData ? new MEscuela(resultData) : null;

                _DICT_ESCUELAS.pendingFetches.delete(idEscuela);
                _DICT_ESCUELAS.set(idEscuela, reqEscuela || null);

                resolve(reqEscuela);
                if (callback) callback();
            });
    });

    _DICT_ESCUELAS.pendingFetches.set(idEscuela, fetchPromise);
    req.Get();
    return fetchPromise;
}

export async function _SvEscuelaObtenerEventosFullArray(): Promise<IEvent[]> {
    if (!_ESCUELA) {
        await new Promise<void>((resolve) => _SvEscuelaObtenerConfiguracion(() => resolve()));
        if (!_ESCUELA) return [];
    }

    return _EVENTS_CHILD_ORDER
        .map(([_, info]) => info)
        .filter(d => {
            const evEVALTipes = [EEventId.MILLESTONE, EEventId.EVALUATION];
            if (evEVALTipes.includes(d.id)) {
                if (_ESCUELA.ModuloEval)
                    return d.id == _ESCUELA.ModuloEval;
                else
                    return d.id == EEventId.MILLESTONE;
            }
            return true;
        })
}

export async function _SvEscuelaObtenerEventosFullMap(): Promise<Partial<{ [k in EEventId]: IEvent }>> {
    return _SvEscuelaObtenerEventosFullArray()
        .then(evts => evts.reduce((res, d) => {
            res[d.id] = d;
            return res;
        }, {}))
}

export function _SvEscuelaClearKinderData() {
    _ESCUELA = null;
}